const React = require('react');
const IconDown = require('../../../icons/Down');
const Slot = require('./Slot');


module.exports = (props) => {
  return (
    <div>
      <Slot {...props}>
        <div className="w70 pr10 layoutRow fhaC fvaC hmin90">
          <IconDown
            className="rlv w20 dn xY5<3:not[.disabled]:h"
          />
        </div>
        <div className="fx1 tl">
          <div
            className="f12 fw7 lts0em"
          >{props.labelHeader}</div>
          <div
            className="mt8 f12 fw3 lts0em"
          >{props.labelContent}</div>
        </div>
      </Slot>
      {
        props.error ? (<div className="rlv">
          <div
            className="abs sh25 st f12 cEC4C4C fw4 ws"
          >Obligatory field</div>
        </div>) : null
      }
    </div>
  );
};
